// extracted by mini-css-extract-plugin
module.exports = {"table":"table_table__1Txxi","wrap":"table_wrap__RXSIV"};